export default {
    contacts: [],
    contactsNewsletter: [],
    contactsEnterprise: [],
    contactsFormSection: [],
    contactsFormHomeSection: [],
}
